import type { Voucher } from '#admin/features/vouchers/api.ts'
import { matchesQuery } from '#admin/lib/text-search.ts'

export const VOUCHER_STATES = ['active', 'inactive'] as const
export type VoucherState = (typeof VOUCHER_STATES)[number]

/**
 * The search and the status filter of the vouchers list. They live in the URL, so a reload or Back
 * keeps the view.
 *
 * Every key is returned, `undefined` when dropped: the router spreads this over the raw search,
 * so a key left out would keep its raw value.
 */
export type VoucherSearch = { q?: string | undefined; status?: VoucherState | undefined }

export function parseVoucherSearch(search: Record<string, unknown>): VoucherSearch {
  const raw = search['q']
  const q = typeof raw === 'string' ? raw.trim().slice(0, 200) : ''
  return {
    q: q === '' ? undefined : q,
    status: VOUCHER_STATES.find((state) => state === search['status']),
  }
}

export function voucherState(voucher: Pick<Voucher, 'isActive'>): VoucherState {
  return voucher.isActive ? 'active' : 'inactive'
}

/** The search looks in the code and the name. */
export function matchesVoucher(
  voucher: Pick<Voucher, 'code' | 'name' | 'isActive'>,
  search: VoucherSearch,
): boolean {
  return (
    (search.status === undefined || voucherState(voucher) === search.status) &&
    matchesQuery([voucher.code, voucher.name], search.q ?? '')
  )
}
